import nestedComponentForm from 'formiojs/components/_classes/nested/NestedComponent.form';
import { BaseEdit } from '../../configuration-components/base-widget-configuration';
import { CustomComponentType } from '../../../enums';

export default function(...extend: any) {
	return nestedComponentForm(BaseEdit.getTabs(CustomComponentType.loans), ...extend);
}
